<template>
  <div class="container-l">
    <div class="head">
      <img src="../assets/images/logo-cutout.png" alt="Logo cutout" />
      <h2>
        Xsensible <br />
        community
      </h2>
    </div>
    <p>Sign up for Xsensible community</p>
    <div class="center wrapper">
      <img src="../assets/images/check-green.png" alt="Green check icon" />
      <p>
        Success! You have earned 500 Xmiles with your registration. In the next
        months we will notify you per email when it is time to have your shoes
        checked by your preferred Xsensible store.
      </p>
      <div class="xmiles">
        <img src="../assets/images/logo-cutout.png" alt="" />
        <b>500</b>
      </div>
      <router-link to="my-xsensibles">My Xsensible community</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LastStep'
}
</script>

<style lang="scss" scoped>
.container-l {
  margin-top: 160px;
  margin-bottom: 160px;
  padding-left: 20px;
  padding-right: 20px;
}
.wrapper {
  flex-direction: column;
  margin-top: 140px;
  margin-left: -25%;

  .xmiles {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    b {
      font-size: 68px;
      padding: 3px 13px;
      color: #0c6b68;
      background-color: #f6f6f6;
    }
  }

  p {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    max-width: 600px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  a {
    text-decoration: none;
    padding: 14px 22px;
    border: 1px solid;
  }

  @media screen and (max-width: 1023px) {
    margin-left: auto;
  }

  @media screen and (max-width: 767px) {
    margin-top: 60px;
  }
}
</style>
